import React, { useState } from "react";
import { motion } from "framer-motion";
import Navbar from "./Navbar";
import Footer from "./Footer";
import AgentAccessModal from "./AgentAccessModal";

const SectionReveal = ({ children }) => (
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, ease: "easeOut" }}
  >
    {children}
  </motion.div>
);

const PageLayout = ({ children, hero }) => {
  const [agentOpen, setAgentOpen] = useState(false);

  const openAgent = () => setAgentOpen(true);
  const closeAgent = () => setAgentOpen(false);

  return (
    <div
      className="matrix-page overflow-x-hidden"
      style={{
        color: "var(--fg)",
        minHeight: "100vh",
      }}
    >
      <Navbar onTalkAgent={openAgent} />
      <main>
        {hero && <SectionReveal>{hero}</SectionReveal>}
        {children}
      </main>
      <Footer />
      <AgentAccessModal
        open={agentOpen}
        onClose={closeAgent}
      />
    </div>
  );
};

export { SectionReveal };
export default PageLayout;
